<div class="container-fluid">
    <div class="row">
        <div class="col">
            <mat-button-toggle-group class="button-group-style toggle_button_mv" name="fontStyle"
                aria-label="Font Style" #group="matButtonToggleGroup" [(ngModel)]="forecastActualValue" value="weekly">
                <ng-container>
                    <mat-button-toggle value="weekly" ngDefaultControl>
                        {{'HOME.Weekly'| translate}}
                    </mat-button-toggle>
                </ng-container>
                <ng-container>
                    <mat-button-toggle value="monthly" ngDefaultControl>
                        {{'HOME.Monthly'| translate}}
                    </mat-button-toggle>
                </ng-container>
            </mat-button-toggle-group>
        </div>
    </div>
</div>
<app-forecastactualweeklysweden *ngIf="forecastActualValue === 'weekly'">
</app-forecastactualweeklysweden>
<app-forecastactualmonthlysweden *ngIf="forecastActualValue === 'monthly'">
</app-forecastactualmonthlysweden>